// *****管理监听回调，发布信息

const clientList = {};  // 函数列表，存放不同的消息下的回调函数


// 发布消息
function trigger(key,arr){
    let fns = clientList[key];
    // if(key == "alert"){
    //     console.log(fns)
    // }
    if ( !fns || fns.length === 0 ){             // 如果没有人订阅该消息，则返回
        return false;
    }
    for( var i = 0, fn; fn = fns[ i++ ]; ){    //遍历回调函数，依次执行
        fn.call( this, arr ); 
    }
}

// *************************************************************************************

// 消息发布
//从消息池更新到队列
const infoRelease = (obj)=>{  
    for(let key in obj){
        let type_arr = obj[key];
        if(type_arr.length !== 0){
            trigger(key,[...type_arr]);  //发布消息
        }
    }    
}

// 监听对应消息的发布
const listen = (key,fn)=>{
    if ( !clientList[ key ] ){   //如果列表中没有对应消息
        clientList[ key ] = [];   //新建该消息的回调函数数组
    }
    clientList[ key ].push( fn ); // 把监听函数添加到相应数组中
}

const clearFun = ()=>{
    for(let key in clientList){
        clientList[key] = [];
    }
}

export default {
    infoRelease:infoRelease,      // 消息分类并发布
    listen:listen,  // 监听消息发布事件
    clear:clearFun,   //清空监听函数
};




// WEBPACK FOOTER //
// ./src/control/info/info-control.js